import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

import "./style.scss";

const ContactInfo = () => {
    return (
        <div className="contact-info-box">
            <h4>
            I am very excited and enthusiastic to connect and contribute to the community by creating tech solutions. 
            Connect with me right here !
            </h4>
            <div className="contact-option">
                <FaPhoneAlt />
                <span className="text">+91 7620531346</span>
            </div>
            <div className="contact-option">
                <MdEmail />
                <span className="text">bhujbalsandesh52@gmail.com</span>
            </div>
        </div>
    );
};

export default ContactInfo;
